module.exports = __webpack_public_path__ + "static/media/3.2.11d1d118.png";